<template>
  <div class="mobile_vote">
    <div class="mobile_vote_head">
      <div class="mobile_head_left">
        <a @click="goBack()">
          <i class="el-icon-arrow-left"></i>
        </a>
      </div>
      <span class="mobile_head_desc"> </span>
      <div class="mobile_head_right">
        <a @click="refreshList()">
          <i class="el-icon-refresh"></i>
        </a>
      </div>
    </div>
    <div class="mobile_vote_bar" ref="mobileVoteBar">
      <div class="mobile_bar_main">
        <div class="mobile_bar_title">
          {{ voteResultInfo.VoteName }}
        </div>
        <div class="mobile_bar_tips">
          共：{{ voteResultInfo.VoteProjectList.length }}
        </div>
      </div>
    </div>
    <div class="mobile_vote_main" :style="voteMainStyle">
      <div
        style="
          display: -webkit-flex;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: space-between;
          align-items: center;
          padding: 15px 10px 5px 10px;
        "
      >
        <span> 未投票评委（{{ voteProgress.NotVoteUserList.length }}） </span>
        <el-link
          type="primary"
          icon="iconfont icon-banjiang"
          @click="shortlistedScreenVoteAwardCeremony()"
          >颁奖典礼</el-link
        >
      </div>
      <div
        class="mobile_project_box"
        v-for="(project, index) in voteResultInfo.VoteProjectList"
        :key="index"
      >
        <div class="project_item">
          <div class="project_title">
            {{ project.Ranking }}、{{ project.ProjectName }}
          </div>
        </div>
        <div class="project_item">
          <i class="el-icon-s-opportunity icon_left icon_primary"></i>
          <div class="content">
            {{ project.Remark }}
          </div>
          <a
            @click="
              project.IsShowAdditionalRemark = !project.IsShowAdditionalRemark
            "
          >
            <i
              class="el-icon-caret-bottom icon_right icon_primary"
              :style="
                project.IsShowAdditionalRemark
                  ? 'transform: rotate(-180deg);transition: all .5s'
                  : 'transform: rotate(0deg);transition: all .5s'
              "
            ></i>
          </a>
        </div>
        <div class="project_item" v-show="project.IsShowAdditionalRemark">
          <i
            class="el-icon-s-opportunity icon_left icon_warning"
            v-show="project.Remark1"
          ></i>
          <div class="content" v-html="project.Remark1"></div>
        </div>
        <div class="project_item">
          <div class="content">
            <div
              class="font_primary"
              style="
                display: -webkit-flex;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: flex-start;
                align-items: center;
              "
              v-if="voteResultInfo.VoteType === 0"
            >
              <div
                style="margin-right: 20px; white-space: nowrap"
                v-for="(stateItem, stateItemIndex) in project.ProjectStateList"
                :key="stateItemIndex"
              >
                {{ stateItem.Value + '：' + stateItem.VoteNumbers }}
              </div>
            </div>
            <span class="font_primary" v-if="voteResultInfo.VoteType === 1">
              当前排序：{{ project.VoteNum }}
            </span>
            <span class="font_primary" v-if="voteResultInfo.VoteType === 2">
              得分：{{ project.AllScore }}
            </span>
          </div>
          <div class="text_right">原序号：{{ project.ProjectSort }}</div>
        </div>
      </div>
    </div>
    <div class="mobile_vote_foot">
      <el-link @click="endVote()" v-if="voteResultInfo.Status === 1">
        结束投票
      </el-link>

      <el-popover
        placement="bottom"
        width="350"
        trigger="click"
        v-model="switchVoteVisible"
        @show="getShortlistedScreenVoteList()"
      >
        <el-table :data="screenVoteItems" v-loading="switchVoteLoading">
          <el-table-column header-align="right">
            <template slot="header">
              <el-link
                title="关闭"
                icon="el-icon-close"
                :underline="false"
                @click="switchVoteVisible = false"
              ></el-link>
            </template>
            <template slot-scope="scope">
              <el-link
                type="primary"
                @click="openShortlistedScreenVote(scope.row)"
              >
                {{ scope.row.VoteName }}
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-link slot="reference"> 切换投票 </el-link>
      </el-popover>
    </div>
  </div>
</template>
<script>
import voteApi from '../../../api/mobileVote/vote'
import voteManageApi from '../../../api/vote/voteManage'
export default {
  data () {
    return {
      voteProgress: {
        NotVoteUserList: []
      },
      voteResultInfo: {
        VoteProjectList: []
      },
      voteMainStyle: {
        marginTop: '45px'
      },
      screenVoteItems: [],
      switchVoteLoading: false,
      switchVoteVisible: false
    }
  },
  methods: {
    getVoteProgress: function () {
      voteManageApi.getVoteProgress({
        voteId: this.$route.params.vid
      })
        .then(data => {
          this.voteProgress = data
        }).catch(err => {
          return err
        })
    },
    getVoteResult: function () {
      const _this = this
      const openLoading = _this.openLoading()
      voteApi.getVoteResult({
        voteId: _this.$route.params.vid
      }).then(data => {
        _this.voteResultInfo = data
        _this.voteResultInfo.VoteProjectList.forEach(item => {
          _this.$set(item, 'IsShowAdditionalRemark', false)
        })
        _this.$nextTick(() => {
          _this.voteMainStyle.marginTop = (_this.$refs.mobileVoteBar.offsetHeight + 45) + 'px'
        })
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    refreshList: function () {
      this.getVoteProgress()
      this.getVoteResult()
    },
    goBack: function () {
      this.$router.push({ name: 'voteList', params: { mid: this.$route.params.mid } })
    },
    getShortlistedScreenVoteList: function () {
      this.switchVoteLoading = true
      voteApi.getShortlistedScreenVoteList({
        meetingID: this.$route.params.mid
      }).then(data => {
        this.screenVoteItems = data
        this.switchVoteLoading = false
      }).catch(err => {
        this.switchVoteLoading = false
        return err
      })
    },
    openShortlistedScreenVote: function (toVote) {
      const _this = this
      _this.openLoading()
      voteApi.openShortlistedScreenVote({
        FromVoteId: _this.$route.params.vid,
        ToVoteId: toVote.VoteId,
        ToVoteType: toVote.VoteType,
        MeetingId: _this.$route.params.mid
      }).then(data => {
        _this.openLoading().close()
        if (toVote.VoteType === 0) {
          _this.$router.push({ name: 'chairShortlistedScreen', params: { mid: _this.$route.params.mid, vid: toVote.VoteId } })
        }
        if (toVote.VoteType === 3) {
          _this.$router.push({ name: 'chairScreenProjects', params: { mid: _this.$route.params.mid, vid: toVote.VoteId } })
        }
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    shortlistedScreenVoteAwardCeremony: function () {
      const _this = this
      //   _this.openLoading()
      //   voteApi.shortlistedScreenVoteAwardCeremony({
      //     VoteId: _this.$route.params.vid,
      //     MeetingId: _this.$route.params.mid
      //   }).then(data => {
      //     _this.openLoading().close()
      //   }).catch(err => {
      //     _this.openLoading().close()
      //     return err
      //   })
      _this.$router.push({ name: 'chairAwardCeremonyList', params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid } })
    },
    endVote: function () {
      const _this = this
      _this.$confirm('确定结束投票吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'vote_message_box'
      }).then(() => {
        _this.openLoading()
        voteManageApi.endVote({
          VoteId: _this.$route.params.vid,
          BaseNumberType: 2
        }).then(data => {
          _this.getVoteProgress()
          _this.getVoteResult()
          _this.$message({
            type: 'success',
            message: '投票已结束'
          })
        }).catch(err => {
          _this.openLoading().close()
          return err
        })
      }).catch(() => {

      })
    }
  },
  created () {
    this.getVoteProgress()
    this.getVoteResult()
  },
  watch: {
    $route () {
      this.switchVoteVisible = false
      this.getVoteProgress()
      this.getVoteResult()
    }
  }
}
</script>

<style lang="less">
@import '../../../assets/css/mobileVote/vote.css';
</style>
